import Swiper from 'swiper';
import { Navigation, FreeMode, Thumbs, A11y } from 'swiper/modules';
const $ = window.jQuery;


const $DOM = {};
let timelineSwiperThumbs;
let timelineSwiper;

const domCache = () => {
    $DOM.container = $(".timeline-slider");
    if (!$DOM.container.length) {
        return;
    }
    $DOM.swiperContainer = $DOM.container.find("#js-timeline-slider");
    $DOM.swiperContainerThumbs = $DOM.container.find("#js-timeline-slider-thumbs");
    $DOM.thumbsButtons = $DOM.swiperContainerThumbs.find('button[rel]');
}

const initSwiper = () => {
    timelineSwiperThumbs = new Swiper($DOM.swiperContainerThumbs[0], {
        modules: [Navigation, FreeMode, A11y],
        init: false,
        slidesPerView: 'auto',
        spaceBetween: 4,
        // centerInsufficientSlides: true,
        // preventClicksPropagation: false,
        roundLengths: true,
        // centeredSlides: true,
        // centeredSlidesBounds: true,
        slideToClickedSlide: true,
        // freeMode: true,
        watchOverflow: true,
        // watchSlidesProgress: true,
        a11y: true,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev'
        },
        breakpoints: {
            768: {
                slidesOffsetBefore: 72,
                slidesOffsetAfter: 72,
            }
        }
    });
    timelineSwiper = new Swiper($DOM.swiperContainer[0], {
        modules: [A11y, Thumbs],
        init: false,
        slidesPerView: 1,
        preventInteractionOnTransition: false,
        speed: 750,
        spaceBetween: 32,
        preventClicksPropagation: false,
        roundLengths: true,
        centeredSlides: true,
        autoHeight: true,
        // loop: true,
        a11y: true,
        navigation: false,

        allowTouchMove: false, // preventing the touch slide - only navigate with pagination swiper

        watchOverflow: true,
        thumbs: {
            swiper: timelineSwiperThumbs,
        },
    });


    timelineSwiperThumbs.on("init", onInitThumbs);
    timelineSwiperThumbs.on("keydown", (e) => {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        let slideIndex = e.target.dataset.slideIndex;
        if (!slideIndex) return;
        timelineSwiperThumbs.slideTo(slideIndex);
        // timelineSwiper.slideTo(slideIndex);
    });
    timelineSwiperThumbs.init();


    timelineSwiper.on("init", onInitMain);
    // timelineSwiper.on("activeIndexChange", onActiveIndexChange);
    timelineSwiper.init();
}

const onInitThumbs = () => {
    $DOM.swiperContainerThumbs.addClass("is-init");
}

const onInitMain = () => {
    $DOM.swiperContainer.addClass("is-init");
    // setTxtPaginationActiveItem(0);
}

const handleThumbsButtons = () => {
    $DOM.thumbsButtons.on("keydown", function (e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return; // using "spacebar" and "send" to navigate
        const slideIndex = parseInt($(this).attr("rel"));
        timelineSwiperThumbs.slideTo(slideIndex);
        timelineSwiper.slideTo(slideIndex);
    });
}



const timelineSlider = {
    init: () => {
        domCache();
        if (!$DOM.container.length) {
            return;
        }
        initSwiper();
        handleThumbsButtons();
    }
};

export default timelineSlider;